
import hash from "../../hash";

import { createApp } from "vue";

import Fuse from 'fuse.js'

import diacritics from 'diacritics';
import { ModalHelper, avatar, validateEmail, bootbox } from "../../B2bTools";
import { traduit } from "../composant/b2bLangue";

import htmlUsers from "./users.html";
import htmlUserNew from "./user@new.html";
import htmlUserBuyerNew from "./user@buyerNew.html";

const mapUserToVueData = function (user) {
    let fusegroups = user.groups.map(u => {
        return u.v
    })
    let fuseindex = user.displayname + " " + user.email + " " + user.k;

    return {
        _id: user._id,
        displayname: user.displayname,
        email: user.email,
        profil: user.profil || '',
        type: (user.profil == "dmk-buy") ? 'buyer' : 'intern',
        reps: user.reps,
        role: user.role,
        status: user.status,
        groups: user.groups,
        title: user.title,
        initial: user.initial,
        notification: user.notification,
        show: true,
        // FUSE
        fusekey: diacritics.remove(fuseindex),
        fusekeygroups: fusegroups.join(" ")
    }
};


const js = ({
    url: function (echangeur) {
        echangeur.addAction('user.liste', {}, 'form', 'users');
        echangeur.addAction('utilisateur.profilList', echangeur.hash, 'form', 'profilList');
        echangeur.addAction('utilisateur.profilsEditables', echangeur.hash, 'form', 'profilsEditables');
        echangeur.addAction('groupe.list', echangeur.hash, 'form', 'groupList');
    },
    onLoad: function (echangeur) {
        let THIS = this;
        //
        let profilsList = echangeur.profilList.rows;
        let profilsEditables = echangeur.profilsEditables.rows.map(el => {
            return profilsList.find(u => {
                return (u.k == el)
            });
        })

        const app = createApp({
            data: function () {
                const isCreateBuyer = profilsEditables.filter(u => (u.k == "dmk-buy")).length;
                const isCreateInterne = profilsEditables.filter(u => (u.k != "dmk-buy")).length;
                return {
                    users: echangeur.users.rows.map(mapUserToVueData),
                    fuse: null,
                    search: null,
                    searchKey: "",
                    searchKeyTable: "",
                    //
                    allSelected: false,
                    selected: [],
                    //
                    triActuel: '',
                    triSens: -1,
                    //choixChart: 'po',
                    //
                    isCreateBuyer: isCreateBuyer,
                    isCreateInterne: isCreateInterne,
                    table: false,
                    type: "intern",
                    count: {
                        all: 0,
                        intern: 0,
                        buyer: 0,
                    },
                    actions: {
                        disable: [],
                        enable: [],
                        selected: null,
                    }
                }
            },
            methods: {

                showUser(usr) {
                    if (this.type == 'all') return true;
                    if (this.type == 'intern' && usr.type != "buyer") return true;
                    if (this.type == "buyer" && usr.type == "buyer") return true;
                    return false
                },

                filtreUserType(type) {
                    this.type = type;
                    this.users.forEach(u => {
                        u.show = this.showUser(u);
                    })

                    // changement de cat client, on remet à 0

                    this.actions.disable = [];
                    this.actions.enable = [];
                    this.selected = [];
                    this.allSelected = false;
                },

                toProfil(k) {
                    const r = echangeur.profilList.rows.find(el => (el.k == k));
                    return (r) ? r.v : k;
                },
                getColor(user) {
                    let a = user.role || user.profil;
                    return avatar.color(a);
                },
                lanceRecherche(val) {
                    const index = 'displayname'
                    const data = this.users
                    let countUserAff = 0;
                    if (data && val) {
                        const searchIndex = this.fuse.search(val).map(u => u.item[index]);
                        data.map(u => {
                            if (u.show) countUserAff += 1;
                            u.inSearch = (searchIndex.includes(u[index]))
                        })
                        if (this.allSelected && _ids.length != countUserAff) this.allSelected = false;
                    }
                },
                // lanceRecherche(val) {
                //     this.search = this.fuse.search(val);
                //     let _ids = this.search.map(e => e.item._id);
                //     let countUserAff = 0;
                //     this.users.map(u => {
                //         u.inSearch = (_ids.indexOf(u._id) > -1);
                //         if (u.show) countUserAff += 1;
                //     })
                //     if (this.allSelected && _ids.length != countUserAff) this.allSelected = false;
                // },

                userNew(userType) {
                    /* console.log(userType); */
                    const modaleApp = createApp({
                        //
                        data: function () {
                            return {
                                saisie: {
                                    displayname: '',
                                    email: '',
                                    profil: '',
                                    title: '',
                                    initial: '',
                                    notif: true,
                                },
                                errors: {
                                    message: null,
                                    email: null,
                                    displayname: null,
                                    profil: null,
                                    title: null,
                                    // initial: null,
                                },

                                profils: profilsEditables.filter(u => u.k != "dmk-buy"),
                            }
                        },
                        methods: {
                            close() {
                                ModalHelper.hide();
                            },
                            async valide() {

                                function nbe(objet) {
                                    let nb = 0;
                                    for (let key in objet) if (objet[key]) nb++;
                                    return nb;
                                }

                                this.errors = {}

                                if (!this.saisie.displayname) this.errors.displayname = true;
                                if (!this.saisie.email) {
                                    this.errors.email = true;
                                } else if (!validateEmail(this.saisie.email)) {
                                    this.errors.email = true;
                                    this.errors.messEmail = "Invalid email ";
                                }


                                // if (!this.saisie.initial) this.errors.initial = true;

                                if (userType != "buyer" && this.saisie.profil == "") this.errors.profil = true;
                                if (userType == "buyer") this.saisie.profil = "dmk-buy";

                                if (!nbe(this.errors)) {
                                    let result = await THIS.rest("user.createUser", { _id: "_new" }, this.saisie);

                                    if (result.errors) {
                                        this.errors.message = result.errors;
                                    } else {
                                        ModalHelper.hide();
                                        hash.lance("userDetail", { _id: result._id });
                                    }
                                }
                            },
                        },
                        mounted() {
                            ModalHelper.show(function () {
                                modaleApp.unmount();
                            });
                        }
                    })
                    //
                    let htmlSaisie = (userType == "buyer") ? htmlUserBuyerNew : htmlUserNew;

                    modaleApp.mount(ModalHelper.html(htmlSaisie).container);

                },
                userDetail(e) {
                    let page = (e.userType == "buyer") ? "userDetailBuyer" : "userDetail";
                    hash.lance(page, { _id: e._id });
                },

                selectAll() {
                    this.selected = [];

                    if (!this.allSelected) {
                        for (let user of this.users) {
                            let selected = user.show;
                            if (user.show && this.searchKey != '' && user.inSearch === false) selected = false;

                            if (selected) this.selected.push(user._id);
                        }
                    }
                },

                tri(name) {
                    const sens = (this.triActuel == name) ? - this.triSens : 1
                    if (name == 'displayname') this.users.sort((a, b) => a[name].localeCompare(b[name]) * sens);
                    if (name == 'email') this.users.sort((a, b) => a[name].localeCompare(b[name]) * sens);
                    if (name == 'status') this.users.sort((a, b) => a[name].localeCompare(b[name]) * sens);
                    if (name == 'profil') this.users.sort((a, b) => a[name].localeCompare(b[name]) * sens);

                    this.triActuel = name
                    this.triSens = sens;
                },

                t(value) {
                    return traduit(value, 'global');
                }
            },
            watch: {
                "checkAll"(val) {
                    //console.log(val)
                },
                "searchKey"(val) {
                    this.lanceRecherche(val);
                },
                "searchKeyTable"(val) {
                    this.lanceRecherche(val);
                },
                "selected"(val) {
                    this.actions.disable = [];
                    this.actions.enable = [];


                    this.users.forEach(u => {
                        if (this.selected.indexOf(u._id) > -1) {
                            if (u.status != 'D') this.actions.disable.push(u);
                            if (u.status == 'D') this.actions.enable.push(u);
                        }
                    })


                }

            },
            mounted() {
                this.users.forEach(u => {
                    u.show = this.showUser(u);
                    if (u.type != "buyer") this.count.intern += 1;
                    else this.count.buyer += 1;
                })
                this.count.all = this.users.length;
                //
                let fuseOptions = { threshold: 0.0, keys: ['displayname', 'fusekey', 'fusekeygroups'] };

                this.fuse = new Fuse(this.users, fuseOptions);


            }
        });

        this.vm = app.mount(THIS.c$('._vueChargement')[0]);

    },


    reprise: async function (ecran) {
        const users = await this.rest('user.liste');
        //
        this.vm.$data.users = users.rows.map(mapUserToVueData);
        this.vm.filtreUserType(this.vm.$data.type)
        //
        this.toggle(true);
        ecran.restaure();
    }

});

export default {
    users: { js: js, html: htmlUsers }
};
